import { useLocation } from "react-router-dom";
import { usePreserveNavigate } from "./usePreserveNavigate";

export const useChangeLanguage = () => {
    const navigate = usePreserveNavigate();
    const location = useLocation();
    const currentSearch = location.search;
    const LANGS = ['hu', "en", "es", "fr", "ru", "pt", "id", "de", "ko", "tr", "zh", "vi", "ja"];

    return (newLang: string) => {
        const pathParts = location.pathname.split("/");
        const oldLang = pathParts[1];

        if (oldLang === newLang) return;

        const isLangPrefixed = LANGS.includes(oldLang);
        const pathWithoutLang = isLangPrefixed
            ? "/" + pathParts.slice(2).join("/") // удаляем текущий язык
            : location.pathname;

        const cleanPath = pathWithoutLang === "/" ? "" : pathWithoutLang;

        let newPath: string;
        if (newLang === "en") {
            // Удаляем префикс для английского
            newPath = cleanPath || "/";
        } else {
            // Добавляем префикс
            newPath = `/${newLang}${cleanPath}`;
        }

        // ✅ Добавляем текущий location.search
        const finalPath = `${newPath}${currentSearch}`;

        navigate(finalPath, { replace: true });
    };
};
